<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5><i class="fa fa-fw fa-book mr-2" />Order</h5>
            <hr />
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="mr-2"
                            v-model="filter.no"
                            type="search"
                            id="filterInput"
                            placeholder="Nomor Order"
                            @keyup.enter="getItems"
                        />
                        <b-form-select class="mr-2" v-model="filter.status" :options="optStatus">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>Status Order</b-form-select-option>
                                <b-form-select-option value="-1">Semua</b-form-select-option>
                            </template>
                        </b-form-select>
                        <multiselect v-model="filter.buyer"
                            class="mr-2"
                            :options="optBuyer"
                            :allow-empty="true"
                            :internal-search="true"
                            deselect-label=""
                            select-label=""
                            label="name"
                            track-by="id"
                            placeholder="Pembeli"
                        />
                        <b-form-input class="mr-2" v-model="filter.start" type="date" />
                        <b-form-group label="s.d." label-cols>
                            <b-form-input class="mr-2" v-model="filter.end" type="date" />
                        </b-form-group>
                        <b-button variant="primary" @click="getItems">
                            <i class="fa fa-search" />
                        </b-button>
                    </div>
                </b-form-group>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada order.
                </template>
                <template v-slot:cell(created)="row">
                    {{ row.item.createdBy }}
                    <div class="small text-muted">{{ row.item.createdAt }}</div>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge :variant="parseStatus(row.item.status)">
                        {{ row.item.status }}
                    </b-badge>
                </template>
                <template v-slot:cell(harga)="row">
                    Rp. {{ $helper.formatThousandSeparator(row.item.totalHarga) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail" @click="openDetailModal(row.item.id)">
                        <i class="fa fa-fw fa-search" />
                    </b-button>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                <b-pagination class="mb-0"
                    v-model="currentPage"
                    :totalRows="totalRows"
                    :per-page="perPage"
                    @change="onPageChange"
                />
            </div>
        </b-card>
        <b-modal id="modal-detail" title="Detail Order" size="lg"
            centered no-close-on-backdrop hide-footer
        >
            <b-spinner v-if="isLoadingDetail" />
            <div v-else>
                <b-row class="mb-3">
                    <b-col md="4">
                        Nomor Order
                        <div class="font-weight-bold">{{ detail.head.no }}</div>
                    </b-col>
                    <b-col md="4">
                        Nama Pembeli
                        <div class="font-weight-bold">{{ detail.head.createdBy }}</div>
                    </b-col>
                    <b-col md="4">
                        Tanggal Pembelian
                        <div class="font-weight-bold">{{ detail.head.createdAt }}</div>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col md="4">
                        Status Order
                        <div class="font-weight-bold text-uppercase">{{ detail.head.status }}</div>
                    </b-col>
                    <b-col md="4">
                        Jumlah Item
                        <div class="font-weight-bold">{{ detail.head.totalJumlah }}</div>
                    </b-col>
                    <b-col md="4">
                        Total Harga
                        <div class="font-weight-bold">Rp. {{ $helper.formatThousandSeparator(detail.head.totalHarga) }}</div>
                    </b-col>
                </b-row>
                <b-row v-if="detail.keterangan != null" class="mb-3">
                    <b-col md="12">
                        Keterangan Penolakan
                        <div>{{ detail.keterangan }}</div>
                    </b-col>
                </b-row>
                <b-table bordered hover
                    :items="detail.details"
                    :fields="modalFields"
                    responsive
                >
                    <template v-slot:cell(name)="row">
                        <b>{{ row.item.model }}</b>
                        <div>{{ row.item.ukuran }} - {{ row.item.warna }}</div>
                    </template>
                    <template v-slot:cell(harga)="row">
                        Rp. {{ $helper.formatThousandSeparator(row.item.harga) }}
                    </template>
                    <template v-slot:cell(total)="row">
                        Rp. {{ $helper.formatThousandSeparator(row.item.total) }}
                    </template>
                </b-table>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'order-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isLoadingDetail: false,
            show: 10,

            input: {
                name: "",
                photo: null,
                kategori: null
            },

            edit: {
                name: "",
                photo: null,
                kategori: null
            },

            filter: {
                no: "",
                status: -1,
                buyer: null,
                start: null,
                end: null
            },

            detail: {
                head: { },
                keterangan: null,
                details: []
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "Nomor Order" },
                { key: "created", label: "Pembeli" },
                { key: "status", label: "Status" },
                { key: "totalJumlah", label: "Jumlah Item" },
                { key: "harga", label: "Total Harga" },
                { key: "action", label: "Aksi" },
            ],

            modalFields: [
                { key: "name", label: "Nama Produk" },
                { key: "sku", label: "SKU" },
                { key: "jumlah", label: "Jumlah" },
                { key: "harga", label: "Harga Satuan" },
                { key: "total", label: "Harga Total" }
            ],

            items: [],
            activeItem: null,

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optBuyer: [],
            optStatus: [
                { text: "Baru", value: 1 },
                { text: "Pengiriman", value: 2 },
                { text: "Ditolak", value: 3 },
                { text: "Selesai", value: 4 }
            ]

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getBuyerOpt = this.$axios.get("user/buyer").then(res => {
                this.optBuyer = res.data
            })

            Promise.all([getItems, getBuyerOpt]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        getItems(page = 1) {

            let query = ""

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(this.filter.buyer != null) {
                param += "&filterUserId=" + this.filter.buyer.id
            }

            // Execute
            return this.$axios.get("order/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        openDetailModal(id) {

            this.isLoadingDetail = true
            this.$bvModal.show("modal-detail")

            this.$axios.get("order/" + id).then(res => {
                console.log(res)
                this.detail = res.data
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isLoadingDetail = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        parseStatus(status) {
            switch(status) {
                case "BARU": return "primary"
                case "PENGIRIMAN": return "dark"
                case "DITOLAK": return "danger"
                case "SELESAI": return "success"
                default: return "light"
            }
        }

    },

    created() {
        this.init()
    }

}
</script>
